import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 GRUPO DE RADIOS

    Va como grupo y no como campo suelto: un radio solo no tiene sentido.
    direction="row" los pone en línea; "column" uno debajo del otro.
*/

export const FieldRadioGroup = ({
    name, label, hint, error, options = [],
    value, onChange, direction = 'column',
    isRequired = false, isDisabled = false,
    span = 1,
}) => (

    <FieldShell label={label} hint={hint} error={error}
        isRequired={isRequired} isDisabled={isDisabled} span={span} >

        <div className={`${BLOCK}__radio_group`} data-direction={direction} role="radiogroup">
            {
                options.map((opt) => (

                    <label key={opt.value} className={`${BLOCK}__check`} htmlFor={`${name}_${opt.value}`}>

                        <input id={`${name}_${opt.value}`} name={name} type="radio"
                            className={`${BLOCK}__check_input`}
                            value={opt.value} checked={value === opt.value}
                            onChange={onChange}
                            required={isRequired} disabled={isDisabled || opt.isDisabled} />

                        <span className={`${BLOCK}__radio_box`} aria-hidden="true">
                            <span className={`${BLOCK}__radio_dot`} />
                        </span>

                        <span className={`${BLOCK}__check_text`}>{opt.label}</span>

                    </label>
                ))
            }
        </div>

    </FieldShell>
);
